import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStateService {
  private signingOut = false;

  beginSignOut(): void {
    this.signingOut = true;
  }

  isSigningOut(): boolean {
    return this.signingOut;
  }
}
